import React, {useContext} from 'react';
import {Button, Col, Descriptions, Row, Space, theme} from 'antd';
import {observer} from "mobx-react";
import {Link, useLoaderData, useNavigate} from "react-router-dom";
import {ButtonBar} from "../../../builder";
import {Translate} from "../../../components/util/translation.util";
import AccessUtil from "../../../components/util/access.util";
import {TranslationDomainEnum} from "../../../types/enums";
import {ViewCardStyled} from "../../../components/styled/card.styled";
import FoAccessUtil from "../../../components/util/foAccess.util";
import FoLink from "../../../components/link/fo.link";
import {StoreContext} from "../../../store.context";
import {Helmet} from "react-helmet-async";
import {BankViewResponse} from "../../../types/modules/bank/response";

export const View: React.FC = observer(() => {
    const { token } = theme.useToken();
    const { appStore: {
        countries,
    }} = useContext(StoreContext);

    const navigate = useNavigate();
    const data: BankViewResponse = useLoaderData() as BankViewResponse;

    return (
            <>
                <Helmet>
                    <title>{`CL BO - ${data?.name}`}</title>
                </Helmet>
        <Space direction="vertical" size="small" style={{ display: 'flex' }}>
            <Row gutter={[8, 8]}>
                <Col span={12}>
                    <Space direction={'vertical'} style={{ width: '100%' }}>
                        <ViewCardStyled title={
                            <Translate message={`bank.title.company`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />
                        } style={{
                            background: token.colorBgContainer,
                        }}>
                            <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                    {data.id && <Descriptions.Item label={<Translate message={`bank.fields.relationalId`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>{ data.id }</Descriptions.Item>}
                                    <Descriptions.Item label={<Translate message={`bank.fields.name`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>{ data.name }</Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`bank.fields.externalId`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>{ data.externalId }</Descriptions.Item>
                                </Descriptions>
                            </div>
                        </ViewCardStyled>

                        <ViewCardStyled title={
                            <Translate message={`bank.title.contact_data`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />
                        } style={{
                            background: token.colorBgContainer,
                        }}>
                            <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                    <Descriptions.Item label={<Translate message={`companyContactData.fields.phone`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.contactData?.phone }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`companyContactData.fields.email`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.contactData?.email }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`bank.fields.location`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.location }
                                    </Descriptions.Item>
                                </Descriptions>
                            </div>
                        </ViewCardStyled>

                        <ViewCardStyled title={
                            <Translate message={`bank.title.address`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />
                        } style={{
                            background: token.colorBgContainer,
                        }}>
                            <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                    <Descriptions.Item label={<Translate message={`companyAddress.fields.country`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { countries.find((country) => { return  country.id === data.address.country})?.name }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`companyAddress.fields.postalCode`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.address.postalCode }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`companyAddress.fields.houseNumber`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.address.houseNumber }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`companyAddress.fields.houseNumberAdditions`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.address.houseNumberAdditions }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`companyAddress.fields.street`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.address.street }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`companyAddress.fields.city`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.address.city }
                                    </Descriptions.Item>
                                </Descriptions>
                            </div>
                        </ViewCardStyled>

                        <ViewCardStyled title={
                            <Translate message={`bank.title.updates`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />
                        } style={{
                            background: token.colorBgContainer,
                        }}>
                            <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                    <Descriptions.Item label={<Translate message={`global.title.created_or_updated_date`} domain={TranslationDomainEnum.MESSAGES} />} span={3}>
                                        { data.modifiedDate }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`global.title.created_or_updated_by`} domain={TranslationDomainEnum.MESSAGES} />} span={3}>
                                        {data.modifiedBy ? (
                                                <AccessUtil access={{ routeName: 'user_view', attributes: [{ id: data.modifiedBy.id  }]}}>
                                                    <AccessUtil access={{ routeName: 'user_view', attributes: [{ id: data.modifiedBy.id  }]}} onDenied={() => {
                                                        return data.modifiedBy?.username ?? data.modifiedBy?.id;
                                                    }}>
                                                        <Link target={"_blank"} to={`/user/${data.modifiedBy?.id}/view`}>{ data.modifiedBy.username ?? data.modifiedBy.id }</Link>
                                                    </AccessUtil>
                                                </AccessUtil>
                                        ) : (
                                                <Translate message={`global.system`} domain={TranslationDomainEnum.MESSAGES} />
                                        )}
                                    </Descriptions.Item>

                                </Descriptions>
                            </div>
                        </ViewCardStyled>
                    </Space>
                </Col>
                <Col span={12}>
                    <Space direction={'vertical'} style={{ width: '100%' }}>
                        <ViewCardStyled title={
                            <Translate message={`bank.title.payment_information`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />
                        } style={{
                            background: token.colorBgContainer,
                        }}>
                            <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                    <Descriptions.Item label={<Translate message={`companyBankData.fields.iban`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.bankData?.iban }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`companyBankData.fields.accountHolderName`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.bankData?.accountHolderName }
                                    </Descriptions.Item>
                                </Descriptions>
                            </div>
                        </ViewCardStyled>

                        <ViewCardStyled title={
                            <Translate message={`bank.title.settings`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />
                        } style={{
                            background: token.colorBgContainer,
                        }}>
                            <div className={`view-block-wrapper`}>
                                <Descriptions bordered>
                                    <Descriptions.Item label={<Translate message={`bank.fields.disabled`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.disabled ? <Translate message={`global.not_active`} /> : <Translate message={`global.active`} /> }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`bank.fields.sendCopyPolicy`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>
                                        { data.sendCopyPolicy ? <Translate message={`global.yes`} /> : <Translate message={`global.no`} /> }
                                    </Descriptions.Item>
                                    <Descriptions.Item label={<Translate message={`bank.fields.hdnId`} domain={TranslationDomainEnum.COMPANY_ADMINISTRATION} />} span={3}>{ data.hdnId }</Descriptions.Item>
                                </Descriptions>
                            </div>
                        </ViewCardStyled>

                    </Space>
                </Col>
            </Row>

            <ButtonBar>
                <AccessUtil access={{ routeName: 'bank_edit', attributes: [{ id: data.id }]}}>
                    <Space>
                        <Button type={`primary`} onClick={ () => navigate(`/bank/${data.id}/edit`) }>
                            <Translate message={`global.button.edit`} />
                        </Button>
                    </Space>
                </AccessUtil>

                <Button type="primary" className={`ant-btn-secondary`} onClick={ () => navigate(`/bank`) }>
                    <Translate message={`global.button.back_to_list`} />
                </Button>

                <FoAccessUtil>
                    <Space>
                        <FoLink path={`/cls/ClsBanks/${data.id}/view_bo_id`} message="global.button.view_in_fo"></FoLink>
                    </Space>
                </FoAccessUtil>

            </ButtonBar>
        </Space>
            </>
    )
})